
import './App.css';
import SportBlock from "./components/sportBlock/sportBlock";

import Banner from "./components/banner/banner";
import Footer from "./components/footer/footer";
import HTTP from "./core/http";
import {useStore} from "effector-react";
import {$store} from "./store";
import Display from "./core/display";
import Loader from "./components/loader/loader";
import Modal from "./components/modal/modal";
import {isModalAllSuccess, isModalBet, isModalBetB, isModalLogin} from "./store/modals";
import moment from "moment";
import PlsLogin from "./components/modals/plsLogin/plsLogin";
import AllSuccess from "./components/modals/allSuccess/allSuccess";
import {confirmPredictions} from "./store/app";
import PlsBet from "./components/modals/plsBet/plsBet";
import PlsBetB from "./components/modals/plsBetB/plsBetB";

HTTP.getConfig();
Display.startService();

function App() {

	const store = useStore($store);

	const onAccept = async ()=>{
		if(store.app.user_authorization) {
			await confirmPredictions();
			if(store.app.is_bet>0) {
				isModalAllSuccess(true);
			} else {
				isModalBetB(true);
			}
		} else {
			isModalLogin(true);
		}
	}
	const onLogin = ()=> {
		isModalLogin(false);
		document.dispatchEvent(new CustomEvent("onLogin"));
	}
	const onRegister = ()=> {
		isModalLogin(false);
		document.dispatchEvent(new CustomEvent("onRegistration"));
	}
	const onOkAllSuccess = ()=> {
		isModalAllSuccess(false);
	}
	const onOkBet = ()=> {
		isModalBet(false);
	}
	const onOkBetB = ()=> {
		isModalBetB(false);
		window.open(store.app.sport_url, '_blank').focus();
	}


	return (
		<div className="App">

			<Banner/>

			{ !!Object.keys(store?.app?.dict).length && <>
					<div className="headerTitles">
						<p className="title1">{store.app.dict?.mainTitle?.choose}</p>
						<p className="title2">{store.app.dict?.mainTitle?.outcomes_matches}</p>
						<div className="titleRowTop">
							<p className="title3">{store.app.dict?.mainTitle?.predictions_accepted_until}</p>
							<p className="title4">{moment(store.app.accepted_date*1000).format("MMM D")}</p>
						</div>
					</div>
				</>
			}


			<section className="content">
				{
					store.app.event.length
					? store.app.event.map((event, i) => {
						return <SportBlock event={event} index={i} key={i}/>
					})
					: <Loader/>
				}
			</section>

			{ !!Object.keys(store?.app?.dict).length && <>
				<div className={`acceptBtn ${Object.keys(store.app.checked).length===4 && "activeBtn"}`}
					 onClick={()=>{onAccept()}}
				>{store.app.dict.mainBtn.make_prediction}</div>

				{ !store.app.user_authorization && <div className="titleRowBottom">
					<p onClick={()=>{ document.dispatchEvent(new CustomEvent("onLogin")); }} className="title5">{store.app.dict?.mainBtn?.log_in}</p>
					<p className="title6">{store.app.dict?.mainBtn?.to_make_prediction}</p>
				</div> }
			</> }

			<Footer/>
			<div className="spaceBottom"/>

			{/* Modals */}
			{ store.modals.isModalLogin && <Modal onClose={()=>{ isModalLogin(false) }}>
				<PlsLogin onLogin={()=>{onLogin()}} onRegister={()=>{onRegister()}}/>
			</Modal> }

			{ store.modals.isModalAllSuccess && <Modal onClose={()=>{ isModalAllSuccess(false) }}>
				<AllSuccess onOk={()=>{onOkAllSuccess()}}/>
			</Modal> }

			{ store.modals.isModalBet && <Modal onClose={()=>{ isModalBet(false) }}>
				<PlsBet onOk={()=>{onOkBet()}}/>
			</Modal> }

			{ store.modals.isModalBetB && <Modal onClose={()=>{ isModalBetB(false) }}>
				<PlsBetB onBet={()=>{onOkBetB()}} onCancel={()=>{ isModalBetB(false) }}/>
			</Modal> }

		</div>
	);
}

export default App;
